let loaded = false
export async function load(additionalResources = () => {}, blocking = true) {
  if (loaded) {
    return
  }
  loaded = true
  return Promise.all([
    loadPdrStyling('./pdr/11/pdr.css'),
    loadPdrStyling('./pdr-legacy/stable/pdr-legacy.css'),
    additionalResources(),
    loadPdr('./pdr/11/pdr.js', '__pdr_dynamic_load_script__', blocking),
    loadPdr('./pdr-legacy/stable/pdr-legacy.js', '__pdr_legacy_dynamic_load_script__', blocking)
  ])
}

function loadPdrStyling(assetPath) {
  return new Promise((resolve, reject) => {
    const $link = document.createElement('link')
    $link.rel = 'preload'
    $link.as = 'style'
    // eslint-disable-next-line
    $link.href = new URL(assetPath, FRONTEND_PACKAGES_URL).href
    $link.addEventListener('load', function load() {
      $link.rel = 'stylesheet'
      $link.removeEventListener('load', load)
      resolve()
    })
    $link.addEventListener('error', function error() {
      $link.removeEventListener('error')
      reject()
    })
    document.head.appendChild($link)
  })
}

function loadPdr(assetPath, scriptId, blocking) {
  return new Promise((resolve) => {
    if (!window.PDR) {
      const src = new URL(assetPath, FRONTEND_PACKAGES_URL).href
      if (blocking) {
        // eslint-disable-next-line no-unsanitized/method
        document.write(`<script src="${src}" id="${scriptId}"><\x2fscript>`)
      } else {
        const $script = document.createElement('script')
        $script.id = scriptId
        $script.src = src
        document.head.appendChild($script)
      }
      document.getElementById(scriptId).addEventListener('load', () => resolve())
    } else {
      resolve()
    }
  })
}
